module.exports = __webpack_public_path__ + "static/media/siddharth-macbook-air.cc40aeda.jpg";